
import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { checkPermission } from 'Permission';

function PermissionRoute({ path, children }) {
    const [isAuth, setIsAuth] = useState(null);

    useEffect(() => {
        checkPermission(path).then((res) => {
            if (!res)
                console.log("No permission");
            setIsAuth(res);
        });
    }, []);

    if (isAuth === null) {
        // The check is still ongoing, you might want to render a loading spinner here
        return null;
    }

    return isAuth ? children : <Navigate to="/" />;
}

export default PermissionRoute;